import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule }  from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { RouterLink } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { HomeContentComponent } from './home-content/home-content.component';
import { CommonAppModule } from '../../common/common-app.module';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HomeDetailComponent } from './home-detail/home-detail.component';
import { MatCardModule } from '@angular/material/card';



@NgModule({
  declarations: [
    HomeComponent,
    HomeContentComponent,
    HomeDetailComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    RouterLink,
    MatMenuModule,
    MatPaginator,
    MatPaginatorModule,    
    MatTableModule,
    MatSortModule,
    MatProgressBarModule ,
    MatCardModule,
    CommonAppModule
  ]
})
export class HomeModule { }
